import { Button, Col, Row } from 'antd';
import { CfSimCompareInfo } from 'domain/entities/SimulateEntity';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SIM_TYPE } from 'utilities/constants/COMMON';
import { SimDetailComponent } from './components/SimDetailComponent';

const CU05903Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { id } = useParams();
    const [data, setData] = React.useState<CfSimCompareInfo>();
    const { simHistory } = location.state;
    const { simulateUseCase } = props;
    const navigate = useNavigate();

    useEffect(() => {
        getDataCompare();
    }, []);

    const getDataCompare = async () => {
        try {
            dispatch(startFetching());
            const response = await simulateUseCase.getSimDetail(Number(id));
            const data = response.result;
            setData({
                ...data,
                simCalcDiv: simHistory.type,
                simulationTitle: simHistory.name,
                listedPropertyId: simHistory.listedPropertyId,
                simulationTiming: simHistory.simulationTiming,
            });
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const gotoDetail = (id: number) => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_03}/${id}`);
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-059-03-container"
        >
            <PageTitle
                title={
                    simHistory.type == SIM_TYPE.BEFORE
                        ? '購入申込時シミュレーション'
                        : '確定シミュレーション'
                }
            />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="form-container w-full">
                    <div className="flex flex-col justify-between items-start w-full">
                        <SimDetailComponent data={data} />
                        <Row className="w-full py-[56px] justify-center">
                            <Col span={12} className="w-full">
                                <Button
                                    type="primary"
                                    size="large"
                                    style={{
                                        height: '56px',
                                    }}
                                    onClick={() => gotoDetail(data?.listedPropertyId ?? 0)}
                                    className="button-container w-full"
                                >
                                    取引詳細へ
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU05903Page;
